// extracted by mini-css-extract-plugin
export default {"wrapper__input":"UiInput_wrapper__input__Au723","input":"UiInput_input__kZoA9","clear":"UiInput_clear__efDzy","clear__disabled":"UiInput_clear__disabled__a911S"};